import { render, staticRenderFns } from "./class-manage.vue?vue&type=template&id=564ac069&scoped=true"
import script from "./class-manage.vue?vue&type=script&lang=js"
export * from "./class-manage.vue?vue&type=script&lang=js"
import style0 from "./class-manage.vue?vue&type=style&index=0&id=564ac069&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564ac069",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('564ac069')) {
      api.createRecord('564ac069', component.options)
    } else {
      api.reload('564ac069', component.options)
    }
    module.hot.accept("./class-manage.vue?vue&type=template&id=564ac069&scoped=true", function () {
      api.rerender('564ac069', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/senate/class-manage.vue"
export default component.exports